/**
 * 设置运费模板
 */
import React from 'react';
import { Modal } from 'antd';
import PropTypes from 'prop-types';
import styles from './TemplateModal.module.scss';
import { XInput, XOKButton, XCancelButton } from '@/components/xqxc_ui';
import { message } from 'antd';
import http from '@/assets/api/http';
import model from '@/reducers/user/member/model';
import { connect } from 'react-redux';
import KeepAlive from '@/routes/KeepAlive';
import { SearchBox, SearchItem } from '@/components/Layout';
import { autoPageNum, autopageSize } from '@/assets/config';
import TableContent from './components/TableContent';

class TemplateModal extends React.Component {

    state = {
        confirmLoading: false,
        templateName: undefined,
        selectedRowKeys: [],
        selectedRows: []
    }

    _handleOk = () => {
        if (this.state.selectedRowKeys.length === 0) {
            message.warning('请选择一条模版记录');
            return;
        }

        http('/?cmd=com.xqxc.api.pig.mis.biz.account.EnterpriseAccountMisService.saveEpDeliveryFeeRule', {
            id: this.props.data.id,
            deliveryFeeRuleId: this.state.selectedRowKeys[0]
        }, 'POST').then(() => {
            message.success('操作成功');
            this.props.closeModal(true);
        }).catch((e) => {
            message.error(e.message);
        });
    }

    _handleCancel = () => {
        this.props.closeModal();
    }

    // 查询触发
    _searchHandle = (useCache) => {
        const { pageNum, pageSize, templateName } = this.state;
        const query = {
            templateName,
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum,
            pageSize: useCache == 'useCache' ? pageSize : autopageSize,
        };
        this.props.getTemplateList(query);
        KeepAlive.saveCache({ ...this.state, pageNum: query.pageNum, pageSize: query.pageSize });
    }

    // 重置触发
    _resetHandle = () => {
        this.setState({ templateName: undefined }, () => {
            KeepAlive.saveResetFunc(this._searchHandle);
        });
    }

    // 每页pageSize条，当前第pageNum页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageSize, pageNum }, () => {
            this._searchHandle('useCache');
        });
    }

    // 表格复选输入
    _rowSelection = {
        type: 'radio',
        onChange: (selectedRowKeys, selectedRows) => {
            this.setState({ selectedRowKeys, selectedRows });
        },
    };

    render() {

        const { confirmLoading, templateName } = this.state;
        const { templateList } = this.props;

        return (
            <Modal
                width='80%'
                centered
                title='选择配送费企业模板'
                visible={true}
                confirmLoading={confirmLoading}
                onOk={this._handleOk}
                onCancel={this._handleCancel}
                destroyOnClose={true}
                keyboard={true}
                maskClosable={false}
                cancelText='取消'
                okText='确认'
            >
                <KeepAlive id='TemplateModal' render={(state) => {
                    if (!this.state.__aliveInit) {
                        this.setState({ ...state, __aliveInit: true }, () => {
                            this._searchHandle('useCache');
                        });
                    }
                }}>
                    <div className={styles.flexBoxContainer} style={{ height: 500 }}>
                        <SearchBox>
                            <SearchItem>
                                <XInput
                                    label='模板名称'
                                    placeholder='请输入'
                                    value={templateName}
                                    bindThis={this}
                                    bindName='templateName'
                                />
                            </SearchItem>
                            <SearchItem>
                                <XOKButton
                                    label='查询'
                                    onClick={this._searchHandle}
                                />
                                <XCancelButton
                                    label='重置'
                                    onClick={this._resetHandle}
                                />
                            </SearchItem>
                        </SearchBox>
                        <TableContent
                            rowSelection={this._rowSelection}
                            renderData={templateList}
                            tableAction={this._tableAction}
                            paginationChange={this._paginationChange}
                        />
                    </div>
                </KeepAlive>
            </Modal>
        );
    }
}

TemplateModal.propTypes = {
    data: PropTypes.object, // 弹窗传递参数
    closeModal: PropTypes.func.isRequired, // 关闭弹框的回调函数
    getTemplateList: PropTypes.func,
    templateList: PropTypes.object,
};

const mapStateToProps = (state) => ({
    templateList: state.member.getTemplateList
});
export default connect(mapStateToProps, { ...model.actions })(TemplateModal);